import React, { Component } from "react"
import { withRouter } from "react-router"
import { withStyles } from "@material-ui/core/styles"
import withWidth from "@material-ui/core/withWidth"
import styles from "./styles"
import { connect } from "react-redux"
import { compose } from "recompose"
import Snackbar from "@material-ui/core/Snackbar"
import { closeSnackBar } from "../../actions/snack-bar"
import Router from "../../routes"
import InviteMemberDialog from "dialogs/InviteMember"
import DialogsContainerDialog from "dialogs/DialogsContainer"
import UpdateUserDialog from "dialogs/UpdateUser"
import IntegrationDialog from "dialogs/Integration"
import PublishContainerDialog from "dialogs/PublishContainer"
import AdminDrawer from "../AdminDrawer"
import AppDrawer from "../AppDrawer"
import DeletingPostDialog from "dialogs/DeletingPost"
import UpdateAccessDialog from "dialogs/UpdateAccess"
import AdditionalField from "dialogs/AdditionalField"
import ResetPasswordDialog from "dialogs/ResetPassword"
import DisconnectIntegrationsDialog from "dialogs/DisconnectIntegrations"
import CreateOrganizationDialog from "dialogs/CreateOrganization"
import FacebookConnected from "dialogs/FacebookConnected"
import clsx from "clsx"
import { isEmpty } from "lodash"
import InstallMessage from "components/InstallMessage"
import { getMagicLink } from "actions/user"
import DeleteOrgDialog from "dialogs/DeleteOrg"
import CropDialog from "dialogs/CropDialog"
import { getLogo } from "actions/organization"
import { getManifest } from "actions/organization"
import { getCurrentOrg } from "actions/organization"
import { logout, loginSuccess } from "actions/authentication"
import FullscreenSpinner from "../FullscreenSpinner"
import { getToken, saveToken } from "utils/cacheToken"
import { getUser } from "actions/user"
import API from "store/api"
import { magicLink } from "actions/authentication"

// Detects if device is on iOS
const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /iphone|ipad|ipod/.test(userAgent)
}
// Detects if device is in standalone mode
const isInStandaloneMode = () =>
  "standalone" in window.navigator && window.navigator.standalone

class App extends Component {
  componentDidMount() {
    if (!isEmpty(this.props.authenticatedUser)) {
      this.changeMagicLink()
    }
    //take the user out if it is not authenticated
    // if (
    //   !window.location.href.includes("login") &&
    //   !window.location.href.includes("register")
    // ) {
    //   this.props.dispatch(getCurrentOrg()).catch(err => {
    //     if (err.status === 401) {
    //       this.props.dispatch(logout())
    //     }
    //   })
    // } else {
    //   this.props
    //     .dispatch(getCurrentOrg())
    //     .catch(error => console.log("ERROR:", error))
    // }

    //change the header when has to change the favicon
    if (window.innerWidth > 700) {
      if (process.env.REACT_APP_ENV === "production") {
        var numberProduction = Math.random()
        var myURLProduction =
          "https://api.firstlinesocial.com/orgs/icon/?cacheBuster=" +
          numberProduction
        document.getElementById("smallFavicon").href = myURLProduction
        var number2Production = Math.random()
        var myURLProduction2 =
          "https://api.firstlinesocial.com/orgs/icon/?cacheBuster=" +
          number2Production
        document.getElementById("bigFavicon").href = myURLProduction2
        fetch("https://api.firstlinesocial.com/orgs/title/")
          .then(response => response.json())
          .then(data => (document.title = data.name))
      } else {
        var number = Math.random()
        var myURL =
          "https://api.firstlinesocial.dev/orgs/icon/?cacheBuster=" + number
        document.getElementById("smallFavicon").href = myURL
        var number2 = Math.random()
        var myURL2 =
          "https://api.firstlinesocial.dev/orgs/icon/?cacheBuster=" + number2
        document.getElementById("bigFavicon").href = myURL2
        fetch("https://api.firstlinesocial.dev/orgs/title/")
          .then(response => response.json())
          .then(data => (document.title = data.name))
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      isEmpty(prevProps.authenticatedUser) &&
      !isEmpty(this.props.authenticatedUser)
    ) {
      // for android
      if (window.deferredPrompt) {
        window.deferredPrompt.prompt()
      }

      // update mnifest on the fly
      this.changeMagicLink()
    }

    if (prevProps.width !== "xs") {
      if (process.env.REACT_APP_ENV === "production") {
        if (
          prevProps.organization.currentOrg.name !==
            this.props.organization.currentOrg.name ||
          this.state.showOnece
        ) {
          var numberProduction = Math.random()
          var myURLProduction =
            "https://api.firstlinesocial.com/orgs/icon/?cacheBuster=" +
            numberProduction
          document.getElementById("smallFavicon").href = myURLProduction
          var number2Production = Math.random()
          var myURLProduction2 =
            "https://api.firstlinesocial.com/orgs/icon/?cacheBuster=" +
            number2Production
          document.getElementById("bigFavicon").href = myURLProduction2
          fetch("https://api.firstlinesocial.com/orgs/title/")
            .then(response => response.json())
            .then(data => (document.title = data.name))
          this.onlyShowOnce()
        }
      } else {
        if (
          prevProps.organization.currentOrg.name !==
            this.props.organization.currentOrg.name ||
          this.state.showOnece
        ) {
          var number = Math.random()
          var myURL =
            "https://api.firstlinesocial.dev/orgs/icon/?cacheBuster=" + number
          document.getElementById("smallFavicon").href = myURL
          var number2 = Math.random()
          var myURL2 =
            "https://api.firstlinesocial.dev/orgs/icon/?cacheBuster=" + number2
          document.getElementById("bigFavicon").href = myURL2
          fetch("https://api.firstlinesocial.dev/orgs/title/")
            .then(response => response.json())
            .then(data => (document.title = data.name))
          this.onlyShowOnce()
        }
      }
    }
  }

  state = {
    showInstallMessage: !isInStandaloneMode() && isIos(),
    // renderRouter: false,
    showOnce: true
  }

  // showInstallMessage = () => {
  //   setTimeout(() => {
  //     // localStorage.setItem("installMessageShown", true)
  //     this.setState({ showInstallMessage: true })
  //   }, 6000)
  // }

  onlyShowOnce = () => {
    this.setState({ showOnce: false })
  }

  handleInstallMessageClick = () => {
    this.setState({ showInstallMessage: false })
  }

  changeMagicLink = () => {
    /* eslint-disable */

    this.props
      .dispatch(getMagicLink(this.props.authenticatedUser.id))
      .then(res => {
        const subdomain = window.location.hostname.split(".")[0]
        const icon192 =
          subdomain === this.props.organization.currentOrg.subdomain &&
          this.props.organization.currentOrg.white_labeled === 1
            ? JSON.parse(results[0].logo).secure_url.split("upload")[0] +
              "upload/c_scale,w_192,r_max" +
              JSON.parse(results[0].logo).secure_url.split("upload")[1]
            : "https://res.cloudinary.com/firstline-social/image/upload/c_scale,w_192,r_max/v1612461508/android-chrome-192x192_ylskwm.png"

        const icon256 =
          subdomain === this.props.organization.currentOrg.subdomain &&
          this.props.organization.currentOrg.white_labeled === 1
            ? JSON.parse(results[0].logo).secure_url.split("upload")[0] +
              "upload/c_scale,w_256,r_max" +
              JSON.parse(results[0].logo).secure_url.split("upload")[1]
            : "https://res.cloudinary.com/firstline-social/image/upload/c_scale,w_256,r_max/v1612461492/android-chrome-256x256_sak1c6.png"

        const icon180 =
          subdomain === this.props.organization.currentOrg.subdomain &&
          this.props.organization.currentOrg.white_labeled === 1
            ? JSON.parse(results[0].logo).secure_url.split("upload")[0] +
              "upload/c_scale,w_180" +
              JSON.parse(results[0].logo).secure_url.split("upload")[1]
            : "https://res.cloudinary.com/firstline-social/image/upload/c_scale,w_180/v1612461492/android-chrome-256x256_sak1c6.png"
        const magicLink = res.magic_link
        const startUrl = `https://${window.location.host}/start/${magicLink}/${this.props.authenticatedUser.id}`
        var manifestObj = {
          name:
            this.props.organization.currentOrg.white_labeled === 1
              ? this.props.organization.currentOrg.name
              : "FirstLine Social",
          short_name:
            this.props.organization.currentOrg.white_labeled === 1
              ? this.props.organization.currentOrg.short_name
              : "FirstLine",
          lang: "en",
          start_url: startUrl,
          scope: `https://${window.location.host}`,
          display: "fullscreen",
          theme_color: this.props.organization.currentOrg.brand_theme,
          background_color: "#ffffff",
          orientation: "portrait",
          icons: [
            {
              src: icon192,
              sizes: "192x192",
              type: "image/png"
            },
            {
              src: icon256,
              sizes: "256x256",
              type: "image/png"
            },
            {
              src: icon180,
              sizes: "180x180",
              type: "image/png"
            }
          ]
        }
        const stringManifest = JSON.stringify(manifestObj)
        const blob = new Blob([stringManifest], { type: "application/json" })
        const manifestURL = URL.createObjectURL(blob)
        document
          .querySelector("#manifest-meta")
          .setAttribute("href", manifestURL)
        // window.prompt(startUrl)
        // eslint-disable-line
      })
      .catch(err => {
        console.log(err)
      })
  }

  render() {
    const { classes } = this.props
    const snackBarOrigin =
      this.props.width === "sm" || this.props.width === "xs"
        ? { vertical: "bottom", horizontal: "left" }
        : { vertical: "bottom", horizontal: "left" }
    return (
      <div className={clsx(classes.app, "mui-fixed")}>
        {/* {this.state.renderRouter && <Router />}
        {!this.state.renderRouter && <FullscreenSpinner />} */}
        <Router />
        <AdminDrawer />
        <AppDrawer />
        <div id="dialog-holder">
          {/* LEAVE THIS IN PLACE FOR DIALOGS TO POPULATE INTO */}
          <InviteMemberDialog />
          <DialogsContainerDialog />
          <UpdateUserDialog />
          <IntegrationDialog />
          <PublishContainerDialog />
          <DeletingPostDialog />
          <UpdateAccessDialog />
          <AdditionalField />
          <ResetPasswordDialog />
          <CreateOrganizationDialog />
          <DisconnectIntegrationsDialog />
          <DeleteOrgDialog />
          <FacebookConnected />
          <CropDialog />
        </div>
        <Snackbar
          anchorOrigin={snackBarOrigin}
          open={this.props.snackBar.open}
          onClose={() => this.props.dispatch(closeSnackBar())}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          autoHideDuration={this.props.snackBar.autoHideDuration}
          message={<span id="message-id">{this.props.snackBar.message}</span>}
        />
        <InstallMessage
          open={this.state.showInstallMessage}
          onClick={this.handleInstallMessageClick}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    snackBar: state.snackBar,
    openUpdateUserDialog: state.updateUserDialog.open,
    authenticatedUser: state.authentication.authenticatedUser,
    token: state.authentication.token,
    organization: state.organization
  }
}

export default withRouter(
  compose(connect(mapStateToProps), withStyles(styles), withWidth())(App)
)



// WEBPACK FOOTER //
// ./src/components/App/index.jsx